import React from 'react'

import { Radio } from '../../Radio'
import { useDropdownContext } from '../DropdownContext'

const RadioOption = ({ ...rest }) => {
  const { onBlur } = useDropdownContext()

  return (
      <Radio
        role="menuitemradio"
        className="radio-option"
        onBlur={onBlur}
        {...rest}
      />
  )
}

export default RadioOption
